export default __webpack_public_path__ + "static/question-16b68d8c1f0c55d41dfa624d99bd35f0.png";